import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import {
    TOP_PERFORMING_METRICS,
    TopFormulasMetricModel,
} from '../../models/metrics.model';

// services
import API from '../../services/api';

// keys
import metricKeys from './_queryKeys';

const getTopFormulasMetrics = async (
    metric_name: TOP_PERFORMING_METRICS,
): Promise<TopFormulasMetricModel[]> => {
    const { data } = await API.getTopFormulaMetric({
        metric_name,
        n_days: 30,
        n_items: 5,
    });
    return data;
};

export default function useGetTopFormulasMetrics(
    metric_name: TOP_PERFORMING_METRICS,
) {
    return useQuery<TopFormulasMetricModel[], BaseError>({
        queryKey: metricKeys.topFormulaMetrics(metric_name),
        queryFn: () => getTopFormulasMetrics(metric_name),
    });
}
